import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    dialogContact: false,
    dialogMentionLegal: false,
  },
  mutations: {
    showContact : function (state,show) {
      state.dialogContact = show
    },
    showMentionLegal : function (state,show) {
      state.dialogMentionLegal = show
    },
  },
  actions: {

  },
  getters: {
    getDialogContact: state => {
      return state.dialogContact
    },
    getDialogMentionLegal: state => {
      return state.dialogMentionLegal
    },
  }
})
